import React from "react";
import { PopoverNext, type PopoverNextProps } from "@blueprintjs/core";

/**
 * `PopoverNext` с умолчаниями прежнего `Popover`, на которых написано приложение.
 *
 * - `lazy`: пока поповер ни разу не открывали, от него нет ничего в DOM. У
 *   `PopoverNext` по умолчанию наоборот: каждый экземпляр сразу вставляет в `body`
 *   пустой портал, а поповеры стоят в ячейках гридов — на таблице договоров это
 *   265 порталов.
 * - `shouldReturnFocusOnClose={false}`: после закрытия фокус не возвращается на
 *   цель. У поповеров по наведению Blueprint и так его не возвращает.
 *
 * Пропсы старого формата (`position`, `minimal`, `modifiers`) `PopoverNext` молча
 * отбрасывает — объект таких пропсов пропускайте через `popoverPropsToNextProps`.
 */
export const PlanrPopover = (props: PopoverNextProps) => (
    <PopoverNext lazy={true} shouldReturnFocusOnClose={false} {...props} />
);
